import consoleAppender from './consoleAppender';

export default {
    appender: consoleAppender,

    debug: function () {
        if (process.env.NODE_ENV == 'test')
            return false;
        try {    
        return localStorage && localStorage["GfDebug"] === "true";
        } catch(_) {
            return false;
        }
    },

    logInfo: function(msg, o) {
        if (this.debug()) {
            this.appender.log({
                msg: msg,
                additionalData: o,
                timeStamp: new Date().toISOString()
            });
        }
    },

    setAppender: function(appender) {
        this.appender = appender;
    }
};
